import {takeEvery, put, call, all, fork} from "redux-saga/effects"

import {
  SEARCH_LIST,
  SEARCH_DOWNLOAD,
} from "./actionTypes"

import {
  searchListSuccess,
  searchListError,
} from "./actions"

import {
  apiPostSearchList,
  apiDownloadSearchDownload,
} from "../../api/calls/search"

function* searchList({payload: data}) {
  try {
    const response = yield call(apiPostSearchList, data)
    yield put(searchListSuccess(response))
  } catch (error) {
    yield put(searchListError(error))
  }
}

function* searchDownload({payload: data}) {
  try {
    yield call(apiDownloadSearchDownload, data)
  } catch (error) {
  }
}

export function* watchSearchList() {
  yield takeEvery(SEARCH_LIST, searchList);
}

export function* watchSearchDownload() {
  yield takeEvery(SEARCH_DOWNLOAD, searchDownload);
}

function* searchSaga() {
  yield all([
    fork(watchSearchList),
    fork(watchSearchDownload),
  ]);
}

export default searchSaga
